import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DraftService } from '../services/draft.service';
import { Project } from '../interfaces/project';

@Component({
  selector: 'app-drafts',
  templateUrl: './drafts.component.html',
  styleUrls: ['./drafts.component.css']
})
export class DraftsComponent implements OnInit {
  drafts: Project[] = [];
  loading = true;

  constructor(
    private draftService: DraftService,
    private router: Router
  ) { }

  async ngOnInit() {
    await this.loadDrafts();
  }

  async loadDrafts() {
    try {
      this.loading = true;
      this.drafts = await this.draftService.getUserDrafts();
    } catch (error) {
      console.error('Error loading drafts:', error);
    } finally {
      this.loading = false;
    }
  }

  editDraft(draft: Project) {
    // Navigate to the form with the draft data
    this.router.navigate(['/new-project'], { 
      queryParams: { draftId: draft.id } 
    });
  }

  async deleteDraft(draft: Project) {
    if (confirm(`Are you sure you want to delete the draft "${draft.title}"?`)) {
      try {
        await this.draftService.deleteDraft(draft.id!);
        await this.loadDrafts(); // Refresh the list
        alert('Draft deleted successfully!');
      } catch (error) {
        console.error('Error deleting draft:', error);
        alert('Error deleting draft. Please try again.');
      }
    }
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString();
  }
}